import React from 'react';
import PropTypes from 'prop-types';
import { getModifiers } from '../../../../helpers';
import HeadingLargeSummaryContent from './HeadingLargeSummaryContent';

const HeadingLargeSummary = ({ htmlTag: HtmlTag, summaryPropsWithContent, modifier }) => (
  <HtmlTag className={`${getModifiers('heading', modifier)} heading--large`}>
    <HeadingLargeSummaryContent summaryPropsWithContent={summaryPropsWithContent} />
  </HtmlTag>
);

HeadingLargeSummary.propTypes = {
  summaryPropsWithContent: PropTypes.array.isRequired,
  modifier: PropTypes.string,
  htmlTag: PropTypes.string
};

HeadingLargeSummary.defaultProps = {
  modifier: '',
  htmlTag: 'h2'
};

export default HeadingLargeSummary;
